import moment from 'moment-timezone';

import { eventConfigOverlapsWithEvent } from '../event-config-overlaps-with-event/event-config-overlaps-with-event';

import { EventConfigsOverlapInput } from './interfaces';

export const eventConfigsOverlap = ({ eventConfig1, eventConfig2, timezone }: EventConfigsOverlapInput): boolean => {
  if (
    eventConfig1.getGenerate() === false ||
    eventConfig2.getGenerate() === false ||
    eventConfig1.getType() !== eventConfig2.getType()
  ) {
    return false;
  }

  const start = moment();
  const end = moment().add(1, 'month');

  const events1 = eventConfig1.generateEventsWithStartBetween(start, end, timezone);

  return events1.some((eventData) =>
    eventConfigOverlapsWithEvent({
      eventConfig: eventConfig2,
      eventData,
      timezone,
    }),
  );
};
